import {ElementUszkodzenia} from '../types/element-uszkodzenia';
import {RodzajElementu} from '../types/rodzaj-elementu';

export class SlownikCache {

  private slownikiElementuUszkodzenCache = new Map<string, ElementUszkodzenia>();
  private slownikiRodzajuElementuCache = new Map<string, RodzajElementu>();

  pobierzSlownikElementuUszkodzen(slownik: string): ElementUszkodzenia | undefined {
    return this.slownikiElementuUszkodzenCache.has(slownik) ? this.slownikiElementuUszkodzenCache.get(slownik) : undefined
  }

  dodajSlownikElementuUszkodzen(slownik: string, elementUszkodzenia: ElementUszkodzenia): void {
    this.slownikiElementuUszkodzenCache.set(slownik, elementUszkodzenia);
  }

  pobierzSlownikRodzajElementu(slownik: string): RodzajElementu | undefined {
    return this.slownikiRodzajuElementuCache.has(slownik) ? this.slownikiRodzajuElementuCache.get(slownik) : undefined
  }

  dodajSlownikRodzajElementu(slownik: string, rodzajelementu: RodzajElementu): void {
    this.slownikiRodzajuElementuCache.set(slownik, rodzajelementu);
  }

}
